import { AnchorHTMLAttributes } from 'react';
import { usePreviewUrl } from '../../../services/PreviewDomain';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { previewUrl: string; domain?: string | null };

export default function VersionPreviewLink({ previewUrl, domain, ...props }: Props) {
  const href = usePreviewUrl(previewUrl, domain);
  return <a {...props} href={href || '#'} />;
}
